/**
 * Settings → Account (web.md §4): Profile · Plan · Sync · Workspace. Profile and Plan are in
 * ProfilePlan.tsx, Sync in Sync.tsx, Workspace in Workspace.tsx.
 */

import { useEntitlement, useSettings } from '../../app/hooks.js';
import { EditorEmpty, type ItemsResult, type SettingsCategory, type SettingsEditorProps } from '../shell/index.js';
import { PlanEditor, ProfileEditor } from './ProfilePlan.js';
import { SyncEditor } from './Sync.js';
import { WorkspaceEditor } from './Workspace.js';

const ITEMS = [
  { id: 'profile', name: 'Profile', icon: 'user' },
  { id: 'plan', name: 'Plan', icon: 'badge-check' },
  { id: 'sync', name: 'Sync', icon: 'refresh-cw' },
  { id: 'workspace', name: 'Workspace', icon: 'settings' },
];

function useItems(): ItemsResult {
  return { items: ITEMS, isLoading: false, error: null };
}

function AccountEditor({ recordId }: SettingsEditorProps) {
  const settings = useSettings();
  const entitlement = useEntitlement();
  if (!settings || !entitlement) return <EditorEmpty text="Loading…" />;
  if (recordId === 'profile') return <ProfileEditor settings={settings} />;
  if (recordId === 'plan') return <PlanEditor entitlement={entitlement} />;
  if (recordId === 'sync') return <SyncEditor entitlement={entitlement} />;
  if (recordId === 'workspace') return <WorkspaceEditor />;
  return <EditorEmpty />;
}

export const category: SettingsCategory = { id: 'account', name: 'Account', icon: 'user', useItems, Editor: AccountEditor };
